// Shared "How It Comes" table cells — renders pack as a readable phrase
// plus an optional Type column.
//
// Usage: <PackCells qty={6} size={105} unit="OZ" mn={mn} sd={sd} />
//        → renders: "6 × 105 OZ"
//
// PackGroupHeader / PackSubHeaders for thead rows.

const BG='rgba(59,130,246,0.03)';
const BG_HEAD='rgba(59,130,246,0.06)';
const BG_GROUP='rgba(59,130,246,0.08)';

function fmtPack(qty,size,unit){
  const q=qty||1;
  const s=size!=null&&size!==0?size:null;
  const u=unit||null;
  if(s!=null&&u)return `${q} × ${s} ${u}`;
  if(s!=null)return `${q} × ${s}`;
  if(u)return `${q} ${u}`;
  return `${q}`;
}

export function PackCells({qty,type,size,unit,mn,sd,dimmed}){
  const color=dimmed?'inherit':undefined;
  const bg=dimmed?'transparent':BG;
  return(<>
    <td style={{...sd,fontSize:9,background:bg,color}}>{type||'—'}</td>
    <td style={{...sd,fontFamily:mn,fontSize:11,background:bg,color,whiteSpace:'nowrap'}}>{fmtPack(qty,size,unit)}</td>
  </>);
}

// Group header row: colSpan for "HOW IT COMES" spanning 2 columns (Type + Pack)
export function PackGroupHeader({sh,colsBefore,colsAfter}){
  return(<>
    <th colSpan={colsBefore} style={sh}/>
    <th colSpan={2} style={{...sh,textAlign:'center',fontSize:9,fontWeight:700,letterSpacing:1.5,color:'#3b82f6',background:BG_GROUP,borderBottom:'none',paddingBottom:0}}>HOW IT COMES</th>
    <th colSpan={colsAfter} style={sh}/>
  </>);
}

// Sub-header row: Type + Pack
export function PackSubHeaders({sh}){
  return(<>
    <th style={{...sh,background:BG_HEAD}}>Type</th>
    <th style={{...sh,background:BG_HEAD}}>Pack</th>
  </>);
}
